/**
 * Trigger a browser download of a Blob by programmatically clicking a temporary anchor.
 *
 * Used for the "Сохранить в WAV" action in the My-Events card. The object URL is revoked right
 * after the click (the browser keeps the download alive internally); the anchor is never attached
 * to the DOM.
 */
export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  // Some browsers ignore `download` without a click in the DOM; a synthetic click is enough.
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Defer revocation a tick so the download has a chance to start under slow event loops.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
